<template>
  <el-dialog
    :title="titlebt"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    append-to-body
  >
    <el-tabs v-model="activeName" @tab-click="handleClick" style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
      <el-tab-pane label="基本材料" name="first">
        <child1  v-if="isChildUpdate1" :agentid_f="agentid_f" ></child1>

      </el-tab-pane>
      <el-tab-pane label="微信" name="second">
        <child2 v-if="isChildUpdate2" :agentid_f2="agentid_f2" ></child2>

      </el-tab-pane>
      <el-tab-pane label="支付宝" name="third">
        <child3 v-if="isChildUpdate3" :agentid_f3="agentid_f3" ></child3>
      </el-tab-pane>
      <el-tab-pane label="随行付" name="fourth">
      <child4 v-if="isChildUpdate4"  :agentid_f4="agentid_f4"></child4>
    </el-tab-pane>
      <el-tab-pane label="银盛" name="five">
        <child5 v-if="isChildUpdate5"  :agentid_f5="agentid_f5"></child5>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>

</template>
<style>
  .customWidth{
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    import tabZujianChild1 from '@/pages/sys/oldparts/tabZfdetails1'
    import tabZujianChild2 from '@/pages/sys/oldparts/tabZfdetails2'
    import tabZujianChild3 from '@/pages/sys/oldparts/tabZfdetails3'
    import tabZujianChild4 from '@/pages/sys/oldparts/tabZfdetails4'
    import tabZujianChild5 from '@/pages/sys/oldparts/tabZfdetails5'
export default {
  name: "oldpartsEditForm",
    components:{
        child1:tabZujianChild1,
        child2:tabZujianChild2,
        child3:tabZujianChild3,
        child4:tabZujianChild4,
        child5:tabZujianChild5
    },
  props: {
      agent: Object,
      accuseVisible:Boolean,
    value: Boolean
  },
  data() {
    return {
        titlebt:'',
        loading: false,
        dialogVisible: false,
        activeName:'first',
        agentid_f:"",
        agentid_f2:"",
        agentid_f3:"",
        agentid_f4:"",
        agentid_f5:"",
      form: {
          businessid: "",
          businessname: "",
          sort_id: ""
      },
        isChildUpdate1:true,
        isChildUpdate2:false,
        isChildUpdate3:false,
        isChildUpdate4:false,
        isChildUpdate5:false
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      accuseVisible (newValue, oldValue) {
          console.log("-----"+newValue);
          this.accuseVisible2 = newValue;

      },

      dialogVisible(val) {
      this.$emit("input", val);
          this.agentid_f=this.agent.agentid;
          this.agentid_f2=this.agent.agentid;
          this.agentid_f3=this.agent.agentid;
          this.agentid_f4=this.agent.agentid;
          this.agentid_f5=this.agent.agentid;
    }
  },
  methods: {
    dialogOpen() {
        this.titlebt="进件详情("+this.agent.agentname+")";
        this.form = {};
    },
      handleClick(tab, event) {
          console.log(tab, event);
          if(tab.name == 'first'){
              // 触发‘配置管理’事件
              this.isChildUpdate1 = true;
              this.isChildUpdate2 = false;
              this.isChildUpdate3 = false;
              this.isChildUpdate4 = false;
              this.isChildUpdate5 = false;
          }else if(tab.name == 'second'){
              // 触发‘用户管理’事件
              this.isChildUpdate1 = false;
              this.isChildUpdate2 = true;
              this.isChildUpdate3 = false;
              this.isChildUpdate4 = false;
              this.isChildUpdate5 = false;
          }else if(tab.name == 'third'){
              // 触发‘用户管理’事件
              this.isChildUpdate1 = false;
              this.isChildUpdate2 = false;
              this.isChildUpdate3 = true;
              this.isChildUpdate4 = false;
              this.isChildUpdate5 = false;
          }else if(tab.name == 'fourth'){
              // 触发‘用户管理’事件
              this.isChildUpdate1 = false;
              this.isChildUpdate2 = false;
              this.isChildUpdate3 = false;
              this.isChildUpdate4 = true;
              this.isChildUpdate5 = false;
          }else if(tab.name == 'five'){
              // 触发‘用户管理’事件
              this.isChildUpdate1 = false;
              this.isChildUpdate2 = false;
              this.isChildUpdate3 = false;
              this.isChildUpdate4 = false;
              this.isChildUpdate5 = true;
          }
      },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

